import { render, staticRenderFns } from "./blessingTiger.vue?vue&type=template&id=5f8e1c64&scoped=true"
import script from "./blessingTiger.vue?vue&type=script&lang=js"
export * from "./blessingTiger.vue?vue&type=script&lang=js"
import style0 from "./blessingTiger.vue?vue&type=style&index=0&id=5f8e1c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e1c64",
  null
  
)

export default component.exports